module.exports = __webpack_public_path__ + "img/t4-i12.d95b2f45.jpg";